import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    categories: [],
    isLoading: false
};

const slice = createSlice({
    name: "blogCategory",
    initialState,
    reducers: {
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        addCategory: (state, action) => {
            state.categories.unshift(action.payload);
        },
        removeCategory: (state, action) => {
            state.categories = state.categories.filter(
                c => c._id !== action.payload
            );
        }
    }
});

export const {
    setCategories,
    addCategory,
    removeCategory
} = slice.actions;

export const BlogCategoryReducer = slice.reducer;